/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialIssuanceConfigRequest
 */
export interface CredentialIssuanceConfigRequest {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    workflowInstanceId: string;
    /**
     * SAID of the bronze id schema
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    schemaId?: string;
    /**
     * AID prefix of the Issuee
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    recipient?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    orgId?: string;
    /**
     * Name of AID of credentials Issuer
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    issuerName?: string;
    /**
     * OOBI for the issuing credentials
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    oobi?: string;
    /**
     * True if the recipient is some automation. False if recipient is human. Those 2 cases require different additional parameters
     * @type {boolean}
     * @memberof CredentialIssuanceConfigRequest
     */
    isRecipientAutomation?: boolean;
    /**
     * AID prefix of the credentials Issuee
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    recipientName?: string;
    /**
     * AID prefix of the Issuer
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    issuerAid?: string;
    /**
     * JSON object of rules OR simple string
     * @type {object}
     * @memberof CredentialIssuanceConfigRequest
     */
    rules?: object;
    /**
     * Credentials parameters, false is default value
     * @type {boolean}
     * @memberof CredentialIssuanceConfigRequest
     */
    privacy?: boolean;
    /**
     * JSON object of source
     * @type {object}
     * @memberof CredentialIssuanceConfigRequest
     */
    source?: object;
    /**
     * JSON object of source
     * @type {object}
     * @memberof CredentialIssuanceConfigRequest
     */
    data?: object;
    /**
     * Issuer automation name
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    issuerAutomation?: string;
    /**
     * Issuee automation name
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    issueeAutomation?: string;
    /**
     * Logo url where can be found Brand logo. Used to issue Brand credentials only
     * @type {string}
     * @memberof CredentialIssuanceConfigRequest
     */
    logoUrl?: string;
}

/**
 * Check if a given object implements the CredentialIssuanceConfigRequest interface.
 */
export function instanceOfCredentialIssuanceConfigRequest(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function CredentialIssuanceConfigRequestFromJSON(json: any): CredentialIssuanceConfigRequest {
    return CredentialIssuanceConfigRequestFromJSONTyped(json, false);
}

export function CredentialIssuanceConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialIssuanceConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'recipient': json['recipient'] == null ? undefined : json['recipient'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'issuerName': json['issuerName'] == null ? undefined : json['issuerName'],
        'oobi': json['oobi'] == null ? undefined : json['oobi'],
        'isRecipientAutomation': json['isRecipientAutomation'] == null ? undefined : json['isRecipientAutomation'],
        'recipientName': json['recipientName'] == null ? undefined : json['recipientName'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'privacy': json['privacy'] == null ? undefined : json['privacy'],
        'source': json['source'] == null ? undefined : json['source'],
        'data': json['data'] == null ? undefined : json['data'],
        'issuerAutomation': json['issuerAutomation'] == null ? undefined : json['issuerAutomation'],
        'issueeAutomation': json['issueeAutomation'] == null ? undefined : json['issueeAutomation'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function CredentialIssuanceConfigRequestToJSON(value?: CredentialIssuanceConfigRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'schemaId': value['schemaId'],
        'recipient': value['recipient'],
        'orgId': value['orgId'],
        'issuerName': value['issuerName'],
        'oobi': value['oobi'],
        'isRecipientAutomation': value['isRecipientAutomation'],
        'recipientName': value['recipientName'],
        'issuerAid': value['issuerAid'],
        'rules': value['rules'],
        'privacy': value['privacy'],
        'source': value['source'],
        'data': value['data'],
        'issuerAutomation': value['issuerAutomation'],
        'issueeAutomation': value['issueeAutomation'],
        'logoUrl': value['logoUrl'],
    };
}

